module.exports = "@font-face {\n    font-family: 'AktivRegular';\n    src: url('AktivRegular.64bd86fcfec81ea1b4c8.ttf');\n  }\n\nbody {\n    background-color: #F7F5F1;\n    font-family: 'AktivRegular';\n}\n\n/* infowindow */\n\n@media (max-width: 767.98px) {\n  .gm-style .gm-style-iw {\n    width: 90% !important; /* Larghezza relativa su mobile */\n    height: auto !important; /* Altezza automatica su mobile */\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles